import React from 'react'; // $FlowFixMe: untyped import

import scrollIntoView from 'scroll-into-view';

var ScrollTo = function ScrollTo(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$topOffset = _ref.topOffset,
      topOffset = _ref$topOffset === void 0 ? 3 : _ref$topOffset,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? 300 : _ref$time;
  var ref = React.useRef();
  React.useEffect(function () {
    if (ref.current) {
      scrollIntoView(ref.current, {
        time: time,
        align: {
          top: 0,
          left: 0,
          topOffset: topOffset
        }
      });
    }
  }, [ref, time, topOffset]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: className
  }, children);
};

export default React.memo(ScrollTo);